import React from 'react';
import { Switch } from 'react-router-dom';
import { Routes } from '@common-packages/routes-definitions';

import { useFetchFilingGroups } from './store/hooks';
import { AuthorizedFilingGroupRoute } from './routeConfiguration/filingGroupRoute.component';
import FilingMembers from './filingMembers/filingMembers.container';
import FilingGroupIdValue from './routeConfiguration/filingGroupIdValue.container';

const FilingGroupRoutes = () => {
  useFetchFilingGroups();
  const filingGroupIdAdditionalValue = <FilingGroupIdValue />;

  return (
    <Switch>
      <AuthorizedFilingGroupRoute
        exact
        path={Routes.federalProFormaFilingMembers.MAIN}
        component={FilingMembers}
        additionalValues={filingGroupIdAdditionalValue}
      />
    </Switch>
  );
};

export default FilingGroupRoutes;
